export const common = {
  "home.awards.title": "Premi e riconoscimenti",
  "home.awards.pause": "Metti in pausa lo scorrimento dei premi",
  "home.awards.play": "Riprendi lo scorrimento dei premi",
  "home.awards.financialAlgorithm": "Leader negli algoritmi finanziari",
  "home.awards.asiaPacificGold": "Marchio leader nel trading di oro in Asia-Pacifico",
  "home.awards.preciousMetals": "Marchio affidabile nel trading di metalli preziosi",
  "home.awards.digitalFinance": "Contributo all’innovazione nella finanza digitale",
  "home.awards.quantitativeTrading": "Eccellenza nella tecnologia di trading quantitativo",
  // Navigation
  'nav.home': 'Home',
  'nav.trading': 'Trading',
  'nav.markets': 'Mercati',
  'nav.news': 'Notizie',
  'nav.about': 'Chi siamo',
  'nav.contact': 'Contatti',
  'nav.login': 'Accedi',
  'nav.register': 'Registrati',

  // Hero Section
  'hero.title': 'Piattaforma premium di trading su oro e argento',
  'hero.subtitle': 'Società con licenza a Hong Kong che offre trading di metalli preziosi sicuro e professionale per gli investitori europei',
  'hero.cta.start': 'Inizia a fare trading',
  'hero.cta.learn': 'Scopri di più',

  // Home
  'home.licenseHK': 'Autorizzata a Hong Kong',
  'home.bankSec': 'Sicurezza di livello bancario',
  'home.247s': 'Supporto 24/7',
  'home.global': 'Focus globale',
  'home.tradingPlat': 'Piattaforma di trading',
  'home.tradingWith': 'Opera con ',
  'home.exp': 'Sperimenta la piattaforma di trading più avanzata al mondo, progettata per il trading di metalli preziosi. MT5 offre strumenti di livello istituzionale, esecuzione fulminea e analisi di mercato complete.',
  'home.dlMT5': 'Scarica MT5',
  'home.watchDemo': 'Guarda la demo',
  'home.tradingIns': 'Strumenti di trading',
  'home.exeSpeed': "Velocità d'esecuzione",
  'home.mktAccess': 'Accesso al mercato',
  'home.uptime': 'Disponibilità',
  'home.allDevices': 'Disponibile su tutti i dispositivi',
  'home.mktInt': 'Intelligence di mercato',
  'home.mktInt.desc': 'Rimani informato con eventi economici in tempo reale e notizie di mercato che influenzano il trading di metalli preziosi',
  'home.lastUpdate': 'Ultimo aggiornamento',
  'home.ecoCal': 'Calendario economico',
  'home.refresh': 'Aggiorna',
  'home.currency': 'Valuta',
  'home.events': 'Eventi',
  'home.previous': 'Precedente',
  'home.forecast': 'Previsione',
  'home.actual': 'Attuale',
  'home.mktNews': 'Notizie di mercato',
  'home.seeMore': 'Vedi altro',
  'home.ecoData': 'Dati economici forniti da più provider finanziari • Notizie di mercato dalle principali testate finanziarie',
  'home.ac': 'Grafici avanzati',
  'home.pta': 'Analisi tecnica professionale con oltre 80 indicatori e strumenti analitici',
  'home.mpa': 'Accesso multi-piattaforma',
  'home.tsa': 'Opera senza interruzioni su applicazioni desktop, web e mobile',
  'home.st': 'Trading sicuro',
  'home.bls': 'Sicurezza di livello bancario con trasmissione e archiviazione dei dati crittografate',
  'home.247': 'Accesso al mercato 24/7',
  'home.rtc': 'Accesso continuativo ai mercati globali dei metalli preziosi',
  'home.at': 'Trading automatizzato',
  'home.ea': 'Expert Advisor (EA) per strategie algoritmiche e automatizzate',
  'home.lfe': 'Esecuzione ultrarapida',
  'home.ull': 'Esecuzione degli ordini a latenza ultra-bassa con spread competitivi',

  // Features
  'features.title': 'Perché scegliere la nostra piattaforma',
  'features.security.title': 'Sicurezza di livello bancario',
  'features.security.desc': 'Crittografia avanzata e protocolli di sicurezza multilivello proteggono i tuoi investimenti',
  'features.licensed.title': 'Completamente autorizzata',
  'features.licensed.desc': 'Società regolamentata a Hong Kong con piena conformità e trasparenza',
  'features.realtime.title': 'Trading in tempo reale',
  'features.realtime.desc': 'Dati di mercato live ed esecuzione istantanea per opportunità ottimali',
  'features.support.title': 'Supporto 24/7',
  'features.support.desc': 'Team di supporto professionale multilingue sempre disponibile',
  'features.lmd': 'Dati di mercato live',
  'features.rtp': 'Prezzi dei metalli preziosi in tempo reale',

  // Markets
  'markets.title': 'Prezzi di mercato live',
  'markets.gold': 'Oro',
  'markets.silver': 'Argento',
  'markets.platinum': 'Platino',
  'markets.palladium': 'Palladio',
  'markets.price': 'Prezzo',
  'markets.change': 'Variazione',
  'markets.high': 'Massimo 24h',
  'markets.low': 'Minimo 24h',
  'markets.contractDetials': 'Dettagli del contratto',
  'markets.contractDetials.desc': 'Specifiche contrattuali complete e condizioni di negoziazione per i metalli preziosi',
  'markets.tradingExample': 'Esempio di trading',
  'markets.goldExample': "Esempio di trading sull'oro",
  'markets.silverExample': "Esempio di trading sull'argento",
  'markets.instrument': 'Strumento',
  'markets.lotSize': 'Dimensione del lotto',
  'markets.entPrice': "Prezzo d'ingresso",
  'markets.marReq': 'Margine richiesto',
  'markets.pip': 'Valore del pip',
  'markets.pmt': 'Trading di metalli preziosi',
  'markets.ctt': 'Termini, condizioni e specifiche complete per il trading di metalli preziosi. Comprendi i dettagli contrattuali, i requisiti di margine e la gestione del rischio per investimenti in oro e argento.',
  'markets.vts': 'Vedi specifiche di trading',
  'markets.dcd': 'Scarica dettagli del contratto',
  'markets.ec': "Velocità d'esecuzione",
  'markets.th': 'Orari di trading',
  'markets.ms': 'Spread minimo (pips)',
  'markets.ml': 'Leva massima',
  'markets.mr': 'Requisiti di margine',
  'markets.lo': 'Opzioni di leva e requisiti di margine per diversi tipi di conto',
  'markets.leverage': 'Leva',
  'markets.margin': 'Margine',
  'markets.mind': 'Deposito minimo',
  'markets.mc': 'Calcolatore di margine',
  'markets.gmc': 'Calcolo margine oro',
  'markets.cp': 'Prezzo attuale',
  'markets.cv': 'Valore del contratto',
  'markets.smc': 'Calcolo margine argento',
  'markets.rm': 'Gestione del rischio',
  'markets.crm': 'Strumenti e strategie completi di gestione del rischio per proteggere i tuoi investimenti',
  'markets.rtg': 'Guida alla tolleranza al rischio',
  'markets.rd': 'Informativa sui rischi',
  'markets.tpm': 'Il trading di metalli preziosi comporta un sostanziale rischio di perdita e potrebbe non essere adatto a tutti gli investitori. Le performance passate non sono indicative di risultati futuri.',
  'markets.lcw': 'La leva può agire sia a tuo favore sia a tuo sfavore. Prima di operare, valuta attentamente i tuoi obiettivi di investimento, il livello di esperienza e la propensione al rischio.',
  'markets.ysb': 'Dovresti conoscere tutti i rischi associati al trading di metalli preziosi e, in caso di dubbi, consultare un consulente finanziario indipendente.',
  'markets.rfr': 'Leggi l’informativa completa sui rischi',
  'markets.cra': 'Contatta un consulente sul rischio',
  'markets.tho': 'Orari di trading',
  'markets.moh': 'Orari di apertura del mercato e calendario festività per il trading di metalli preziosi',
  'markets.wts': 'Programma settimanale di trading',
  'markets.note': 'Nota',
  'markets.atad': 'Tutti gli orari sono visualizzati in GMT+8. Il trading può essere sospeso durante le principali festività e in periodi di elevata volatilità.',
  'markets.hs': 'Calendario festività',
  'markets.mclo': 'Mercato chiuso',
  'markets.eclo': 'Chiusura anticipata',
  'markets.hn': 'Avviso festività',
  'markets.thm': 'Gli orari di trading possono essere modificati durante le festività nazionali. Controlla i nostri annunci per eventuali variazioni.',
  'markets.cms': 'Stato attuale del mercato',
  'markets.mac': 'I mercati sono attualmente APERTI al trading',
  'markets.st': 'Ora del server (GMT+8)',
  'markets.ts': 'Specifiche di trading',
  'markets.dtc': 'Condizioni e specifiche dettagliate per strumenti su oro e argento',
  'markets.msp': 'Spread minimo',
  'markets.minls': 'Lotto minimo',
  'markets.maxls': 'Lotto massimo',
  'markets.commission': 'Commissione',
  'markets.sls': 'Swap long/short',
  'markets.in': 'Note importanti',
  'markets.smv': 'Gli spread possono variare durante periodi di elevata volatilità e importanti annunci',
  'markets.sra': 'I tassi di swap sono aggiornati quotidianamente e possono variare in base alle condizioni di mercato',
  'markets.mlm': 'La leva massima può essere ridotta durante eventi macro ad alto impatto',
  'markets.ata': 'Tutti gli orari sono visualizzati nel fuso orario GMT+8',

  // News
  'news.title': 'Ultime notizie e analisi di mercato',
  'news.subtitle': 'Rimani informato con approfondimenti di esperti e aggiornamenti di mercato',
  'news.readMore': 'Leggi di più',
  'news.category.analysis': 'Analisi di mercato',
  'news.category.news': 'Ultim’ora',
  'news.category.insights': 'Approfondimenti degli esperti',
  'news.category.education': 'Formazione',
  'news.date': 'Pubblicato',
  'news.author': 'Di',

  // Testimonials
  'home.partners.title': 'I nostri partner',
  'home.partners.subtitle': 'Collaboriamo con fornitori globali leader nei settori della liquidità, della tecnologia finanziaria e dell’infrastruttura di trading.',
  'testimonials.title': 'Scelta di fiducia degli investitori in tutto il mondo',
  'testimonials.client1.name': 'Marcus Weber',
  'testimonials.client1.location': 'Francoforte, Germania',
  'testimonials.client1.text': 'Piattaforma eccellente con prezzi trasparenti ed esecuzione affidabile. Le funzioni di sicurezza mi danno piena fiducia.',
  'testimonials.client2.name': 'Sophie Dubois',
  'testimonials.client2.location': 'Parigi, Francia',
  'testimonials.client2.text': 'Servizio professionale e spread competitivi. Il team di supporto multilingue è estremamente utile.',
  'testimonials.client3.name': 'Alessandro Rossi',
  'testimonials.client3.location': 'Milano, Italia',
  'testimonials.client3.text': 'Esecuzione rapida ed eccellenti strumenti di analisi di mercato. Altamente consigliata per un trading serio di metalli preziosi.',

  // Footer
  'footer.company': 'Azienda',
  'footer.trading': 'Trading',
  'footer.support': 'Supporto',
  'footer.legal': 'Legale',
  'footer.about': 'Chi siamo',
  'footer.careers': 'Carriere',
  'footer.news': 'Notizie',
  'footer.platforms': 'Piattaforme di trading',
  'footer.education': 'Formazione',
  'footer.analysis': 'Analisi di mercato',
  'footer.help': 'Centro assistenza',
  'footer.contact': 'Contattaci',
  'footer.faq': 'FAQ',
  'footer.terms': 'Termini di servizio',
  'footer.privacy': 'Informativa sulla privacy',
  'footer.risk': 'Informativa sui rischi',
  'footer.copyright': '© 2024 GOLD Label Global Limited. Tutti i diritti riservati.',
  'footer.license': "Società costituita a Hong Kong",
  'footer.riskwarning': 'Avvertenza sui rischi',
  'footer.disclaimer': 'Il trading con margine è un prodotto finanziario a leva che può comportare perdite superiori ai depositi. Non possiedi né detieni effettivamente alcun bene sottostante. Leggi attentamente la nostra Informativa sui rischi prima di operare. Assicurati di comprendere pienamente i rischi coinvolti e gestire prudentemente la tua esposizione. Non ci assumiamo alcuna responsabilità per azioni od omissioni intraprese da individui sulla base delle informazioni presenti su questo sito o dei suoi contenuti.',
  'footer.jurisdiction': "Avviso sulle giurisdizioni",
  'footer.jurisdictionDisclaimer': "I servizi sono offerti esclusivamente a clienti idonei in giurisdizioni al di fuori di Hong Kong e degli Stati Uniti, a condizione che la loro fornitura sia consentita dalle leggi applicabili nella giurisdizione del cliente. I servizi non sono offerti ai residenti di Hong Kong o degli Stati Uniti, né a persone in giurisdizioni in cui tali servizi siano illegali o vietati. Questo sito web non è rivolto a persone in giurisdizioni soggette a restrizioni e non costituisce nei loro confronti un'offerta, una sollecitazione o una raccomandazione.",
  'footer.relatedEntity': 'Altra entità collegata',
  'footer.saintLuciaEntity': "Gold Label Global (SL) Limited è una International Business Company costituita a Santa Lucia il 4 settembre 2026, con numero di registrazione 2026-00680. Sede legale: Ground Floor, The Sotheby Building, Rodney Village, Rodney Bay, Gros-Islet, Saint Lucia. La sede legale è mantenuta esclusivamente per finalità di conformità legale e regolamentare. Non costituisce la sede operativa della società e non viene utilizzata per attività operative, visite dei clienti o corrispondenza.",
  'footer.regNo': 'Numero di registrazione della società',

  // Common
  'common.language': 'Lingua',
  'common.loading': 'Caricamento…',
  'common.error': 'Errore',
  'common.success': 'Operazione riuscita',
  'common.close': 'Chiudi',
  'common.save': 'Salva',
  'common.cancel': 'Annulla',
  'common.continue': 'Continua',
  'common.back': 'Indietro',
  'common.next': 'Avanti',
  'common.previous': 'Precedente',
  'common.submit': 'Invia',
  'common.reset': 'Reimposta',


  // About
  'about.yearsOfExp': 'Anni di esperienza',
  'about.yearsOfExp.desc': 'Decenni di esperienza nel trading di metalli preziosi',
  'about.dailyTrade': 'Volume di trading giornaliero',
  'about.dailyTrade.desc': '80 miliardi HK$ di transazioni giornaliere su oro e argento',
  'about.satClients': 'Clienti soddisfatti',
  'about.satClients.desc': 'Al servizio di innumerevoli clienti e istituzioni in tutto il mondo',
  'about.exeSpeed': "Velocità d'esecuzione",
  'about.exeSpeed.desc': "Tecnologia di esecuzione degli ordini fulminea",
  'about.ourAch': 'I nostri risultati',
  'about.ourAch.desc': 'Eccellenza riconosciuta nel trading di metalli preziosi con performance leader del settore',
  'about.companyProfile': 'Profilo aziendale',
  'about.about1': 'Chi è Gold Label Global',
  'about.about2': 'Gold Label Global Limited è una società a responsabilità limitata registrata e approvata dal governo di Hong Kong ed è membro della Chinese Gold and Silver Exchange Society. Hong Kong gestisce ogni giorno transazioni di oro e argento per un valore di 80 miliardi di HK$, con un’esperienza leader a livello mondiale.',
  'about.about3': 'Il team di gestione di Gold Label Global vanta oltre vent’anni di esperienza mirata nel trading di oro e argento. Abbiamo servito innumerevoli clienti e istituzioni, gestendo operazioni per decine di miliardi, ricevendo grande apprezzamento da clienti e professionisti del settore.',
  'about.about4': 'Ci impegniamo a fornire ai clienti ambienti di trading rapidi, stabili ed eccellenti. A livello tecnico adottiamo sistemi di negoziazione di livello internazionale e selezioniamo team tecnologici di prim’ordine per sviluppare soluzioni più potenti e complete, migliorando la velocità di esecuzione affinché sia più rapida, stabile e completa.',
  'about.about5': 'Gold Label Global continuerà a creare profitti con voi e a condividere la prosperità.',
  'about.about6': 'Scopri il nostro percorso nel trading di metalli preziosi e il nostro impegno per l’eccellenza nei mercati finanziari globali.',
  'about.about7': 'In quanto società a responsabilità limitata registrata e approvata dal governo di Hong Kong e membro della Chinese Gold & Silver Exchange Society, gestiamo 80 miliardi di HK$ in transazioni giornaliere su oro e argento, guidando il mondo per esperienza di trading.',
  'about.proTeam': 'Team professionale',
  'about.proTeam.desc': 'Il nostro management ha oltre 20 anni di esperienza focalizzata sul trading di oro e argento, con servizio a innumerevoli clienti e istituzioni.',
  'about.proService': 'Servizio professionale',
  'about.proService.desc': 'Team di assistenza professionale con servizio clienti online 24 ore su 24 e consulenza mobile, oltre a soluzioni mirate ai problemi dei clienti.',
  'about.sec': 'Sicurezza prima di tutto',
  'about.sec.desc': 'Nessuna controparte di negoziazione: le operazioni entrano direttamente nel mercato, con trasparenza e sicurezza.',
  'about.strict': 'Vigilanza rigorosa',
  'about.strict.desc': 'Gold Label Global è una sede di negoziazione commerciale a Hong Kong, regolamentata dal governo di Hong Kong e membro dell’Associazione del Commercio Commerciale di Hong Kong.',
  'about.fastDes': 'Deposito veloce',
  'about.fastDes.desc': 'Servizio operativo 24 ore, accredito in pochi secondi e apertura conto immediata.',
  'about.productSafe': 'Sicurezza del prodotto',
  'about.productSafe.desc': 'Copertura di tutti i principali prodotti globali di metalli preziosi, con sicurezza garantita.',
  'about.whyGLB': 'Perché scegliere Gold Label Global',
  'about.whyGLB.desc': 'Scopri i vantaggi che ci rendono la scelta leader per il trading di metalli preziosi',
  'about.readyToStart': 'Pronto per iniziare a fare trading?',
  'about.join': 'Unisciti a migliaia di clienti soddisfatti che si affidano a GOLD Label Global per le loro esigenze di trading di metalli preziosi.',
  'about.openTradingAcc': 'Apri un conto di trading',
  'about.contactTeam': 'Contatta il nostro team',
  'about.co': 'Collaborazione',
  'about.co.desc': 'Costruire partnership reciprocamente vantaggiose con i nostri clienti e stakeholder',
  'about.safety': 'Sicurezza',
  'about.safety.desc': 'Garantire il massimo livello di sicurezza per tutte le attività di trading',
  'about.integrity': 'Integrità',
  'about.integrity.desc': 'Mantenere i più elevati standard di onestà e trasparenza',
  'about.professional': 'Professionalità',
  'about.professional.desc': 'Erogazione di servizi esperti con professionalità senza pari',
  'about.fast': 'Rapidità',
  'about.fast.desc': "Fornire esecuzione rapida e un'assistenza clienti reattiva",
  'about.coreValue': 'I nostri valori fondamentali',
  'about.coreValue.desc': "I principi che guidano il nostro impegno per l'eccellenza nel trading di metalli preziosi",

  // Contact
  'contact.sendUsMsg': 'Inviaci un messaggio',
  'contact.fillOut': 'Compila il modulo qui sotto e il nostro team ti ricontatterà entro 24 ore.',
  'contact.inqType': 'Tipo di richiesta',
  'contact.genInq': 'Richiesta generale',
  'contact.accSup': 'Assistenza account',
  'contact.traSup': 'Assistenza trading',
  'contact.techSup': 'Assistenza tecnica',
  'contact.partner': 'Partnership',
  'contact.fullname': 'Nome e cognome *',
  'contact.email': 'Indirizzo e-mail *',
  'contact.phone': 'Numero di telefono',
  'contact.subject': 'Oggetto *',
  'contact.msg': 'Messaggio *',
  'contact.sendMsg': 'Invia messaggio',
  'contact.whyUs': 'Perché scegliere noi?',
  'contact.regSec': 'Regolamentati e sicuri',
  'contact.licAndReg': 'Ambiente di negoziazione autorizzato e regolamentato con misure di sicurezza avanzate per proteggere i tuoi investimenti.',
  'contact.expSup': 'Supporto esperto',
  'contact.proService': 'Specialisti di trading disponibili 24/7 per assisterti con esigenze e domande.',
  'contact.fastExe': 'Esecuzione rapida',
  'contact.lightFast': "Esecuzione degli ordini ultrarapida con slippage minimo per prestazioni ottimali.",
  'contact.glbNet': 'Mercati globali',
  'contact.asscessToint': 'Accesso ai mercati internazionali dei metalli preziosi con spread competitivi e profonda liquidità.',
  'contact.followUs': 'Seguici sui social:',
  'contact.contactOutPro': 'Contatta il nostro team professionale per assistenza al trading, supporto account o richieste generali:',
  'contact.officeAddress': 'Indirizzo dell’ufficio',
  'contact.bussHour': 'Orari di lavoro: Lun–Ven 9:00–18:00 (GMT+8)',
  'contact.phoneSupp': 'Assistenza telefonica',
  'contact.mainOffice': 'Sede principale',
  'contact.availableServices': 'Servizi disponibili:',
  'contact.accOpenSup': 'Supporto apertura conto',
  'contact.tradSup': 'Assistenza piattaforma di trading',
  'contact.genSup': 'Supporto generale',
  'contact.emailSup': 'Assistenza via e-mail',
  'contact.responseTime': 'Tempo di risposta:',
  'contact.genInq24': 'Richieste generali: entro 24 ore',
  'contact.techSup24': 'Assistenza tecnica: entro 4 ore',
  'contact.accIss24': 'Problemi di account: entro 2 ore',
  'contact.needImSup': 'Hai bisogno di assistenza immediata?',
  'contact.needImSup.desc': 'I nostri specialisti di trading sono disponibili 24/7 per aiutarti con questioni urgenti e supporto all’account.',
  'contact.callNow': 'Chiama ora',
  'contact.sendEmail': 'Invia e-mail',
  'contact.contactUs': 'Contattaci',
  'contact.getInTouch': 'Mettiti in contatto con il nostro team professionale di trading. Siamo qui per aiutarti ad avere successo nel trading di metalli preziosi.',
  'contact.247Sup': 'Supporto 24/7',
  'contact.247Sup.desc': 'Assistenza clienti continuativa per tutte le esigenze di trading',
  'contact.dirLine': 'Linea diretta',
  'contact.dirLine.desc': 'Parla direttamente con i nostri specialisti di trading',
  'contact.hkOffice': 'Ufficio di Hong Kong',
  'contact.hkOffice.desc': 'Situato nel cuore del distretto finanziario di Hong Kong',

  // Platform
  'platform.wco': 'Perché scegliere la nostra piattaforma MT5?',
  'platform.etd': 'Scopri la differenza con la nostra piattaforma premium progettata per trader esigenti',
  'platform.rts': 'Pronto per iniziare a fare trading?',
  'platform.jto': 'Unisciti a migliaia di trader che si affidano alla nostra piattaforma per il trading di metalli preziosi',
  'platform.ola': 'Apri conto reale',
  'platform.tda': 'Prova conto demo',
  'platform.dmt': 'Scarica la piattaforma MT5',
  'platform.ayt': 'Accedi al tuo conto di trading da qualsiasi dispositivo con le nostre app MT5 multipiattaforma',
  'platform.free': 'Gratuito',
  'platform.dn': 'Scarica ora',
  'platform.sr': 'Requisiti di sistema',
  'platform.nh': 'Hai bisogno di aiuto per iniziare?',
  'platform.os': 'Il nostro team di supporto è pronto ad aiutarti nella configurazione e nell’avvio',
  'platform.ug': "Guida dell'utente",
  'platform.cs': 'Contatta il supporto',
  'platform.si': 'Richiesta connessione Internet stabile',
  'platform.ptf': 'Potenti funzionalità di trading',
  'platform.epg': 'Strumenti professionali progettati per principianti ed esperti',
  'platform.ac': 'Grafici avanzati',
  'platform.pct': 'Strumenti di charting professionali con oltre 80 indicatori tecnici e più timeframe per un’analisi completa.',
  'platform.lfe': 'Esecuzione ultrarapida',
  'platform.ull': "Trading a latenza ultra-bassa con velocità d'esecuzione fino a 0,01 secondi per ingressi e uscite ottimali.",
  'platform.ea': 'Expert Advisor (EA)',
  'platform.atc': 'Trading automatizzato con EA personalizzati e strategie algoritmiche.',
  'platform.rm': 'Gestione del rischio',
  'platform.crm': 'Strumenti completi di gestione del rischio: stop loss, take profit e controllo della dimensione posizione.',
  'platform.mpa': 'Accesso multipiattaforma',
  'platform.tsa': 'Opera senza interruzioni su desktop, web e mobile con accesso sincronizzato al conto.',
  'platform.gm': 'Mercati globali',
  'platform.ati': 'Accesso a mercati internazionali tra cui metalli preziosi, forex, indici e materie prime.',
  'platform.etw': 'Sperimenta la piattaforma di trading più avanzata al mondo. Negozia metalli preziosi, forex e CFD con tecnologia di livello istituzionale ed esecuzione fulminea.',
  'platform.download': 'Scarica ',
  'platform.wd': 'Guarda la demo',
  'platform.es': "Velocità d'esecuzione",
  'platform.th': 'Orari di trading',
  'platform.in': 'Strumenti',
  'platform.lt': 'Trading live',
  'platform.ptt': 'Strumenti di trading professionali',
  'platform.aig': 'Accedi a strumenti di livello istituzionale per trader professionisti e investitori seri',
  'platform.rtd': 'Dati in tempo reale',
  'platform.lmd': 'Dati di mercato live e aggiornamenti istantanei dei prezzi',
  'platform.pa': 'Avvisi di prezzo',
  'platform.caf': 'Avvisi personalizzati per movimenti di prezzo ed eventi di mercato',
  'platform.this': 'Storico operazioni',
  'platform.cth': 'Storico di trading completo e analisi delle performance',
  'platform.ec': 'Calendario economico',
  'platform.suw': 'Rimani aggiornato sugli eventi economici importanti',
  'platform.mw': 'Market Watch',
  'platform.rtp': 'Quotazioni in tempo reale e profondità di mercato per tutti gli strumenti',
  'platform.om': 'Gestione ordini',
  'platform.aot': 'Tipi di ordine avanzati: market, limit, stop e trailing stop',
  'platform.ta': 'Analisi tecnica',
  'platform.cta': 'Strumenti completi di analisi tecnica con indicatori personalizzati e strumenti di disegno',
  'platform.ufe': 'Esecuzione ultra-rapida',
  'platform.rtc': 'Assistenza clienti continuativa fornita dal nostro team di esperti di trading e specialisti tecnici',
  'platform.247a': 'Disponibile 24/7',
  'platform.csp': 'Spread competitivi',
  'platform.iia': 'Spread leader di settore e prezzi trasparenti senza commissioni o costi nascosti',
  'platform.01pip': 'Da 0,1 pips',
  'platform.ffd': 'App desktop completa per Windows 10/11',
  'platform.nma': 'App nativa macOS con funzionalità complete',
  'platform.mta': 'App di trading per dispositivi Android',
  'platform.iai': 'App di trading per iPhone e iPad',

  // FAQ SECTION
  'faq.tagline': 'COME POSSIAMO AIUTARTI?',
  'faq.title': 'Come possiamo aiutarti?',
  'faq.subtitle': 'Esplora le nostre sezioni FAQ complete per trovare rapidamente le risposte alle tue domande',
  'faq.categories': 'Categorie',

  // Footer help box
  'faq.cantFind': 'Non trovi quello che cerchi?',
  'faq.supportText': 'Il nostro team di supporto è a disposizione per rispondere a qualsiasi domanda non coperta nella sezione FAQ.',
  'faq.contactSupport': 'Contatta il team di supporto',

  // Category titles
  'faq.general': 'Generale',
  'faq.account': 'Account',
  'faq.trading': 'Trading',
  'faq.platform': 'Piattaforma',
  'faq.deposits': 'Depositi e prelievi',
  'faq.security': 'Sicurezza',

  // General
  'faq.general.q1': 'Che cos’è GOLD LABEL GLOBAL LIMITED?',
  'faq.general.a1': 'GOLD LABEL GLOBAL LIMITED è una società regolamentata di trading di metalli preziosi con sede a Hong Kong, che offre servizi professionali su oro, argento e altri metalli preziosi tramite la piattaforma MT5.',
  'faq.general.q2': 'Quali strumenti di trading offrite?',
  'faq.general.a2': 'Offriamo un’ampia gamma di metalli preziosi, tra cui oro spot (XAU/USD), argento spot (XAG/USD), platino, palladio e vari contratti futures su metalli preziosi.',
  'faq.general.q3': 'Quali sono i vostri orari di negoziazione?',
  'faq.general.a3': 'I nostri mercati dei metalli preziosi sono aperti 24 ore su 24, 5 giorni a settimana, dalla domenica alle 17:00 EST al venerdì alle 16:00 EST, secondo gli orari internazionali.',
  'faq.general.q4': 'Il mio investimento è al sicuro con la vostra azienda?',
  'faq.general.a4': 'Sì, siamo pienamente regolamentati e autorizzati. I fondi dei clienti sono segregati e detenuti in conti bancari sicuri. Manteniamo inoltre una copertura assicurativa completa per ulteriore protezione.',

  // Account
  'faq.account.q1': 'Come apro un conto di trading?',
  'faq.account.a1': 'Puoi aprire un conto online compilando il nostro modulo, fornendo i documenti di identità richiesti ed effettuando un deposito iniziale. Il processo richiede in genere 1–2 giorni lavorativi.',
  'faq.account.q2': 'Qual è il deposito minimo richiesto?',
  'faq.account.a2': 'Il deposito iniziale minimo è di 1.000 USD per un conto standard. Offriamo anche conti premium con depositi minimi più elevati e vantaggi aggiuntivi.',
  'faq.account.q3': 'Posso avere più conti di trading?',
  'faq.account.a3': 'Sì, puoi aprire più conti con diverse valute di base o tipologie per adattarti alle tue strategie e alla gestione del rischio.',
  'faq.account.q4': 'Come verifico il mio account?',
  'faq.account.a4': 'La verifica richiede un documento di identità rilasciato dal governo (passaporto o patente) e una prova di residenza (utenza o estratto conto) datata negli ultimi 3 mesi.',

  // Trading
  'faq.trading.q1': "Qual è la dimensione minima dell'operazione?",
  'faq.trading.a1': 'La dimensione minima è di 0,01 lotti per la maggior parte degli strumenti sui metalli preziosi, consentendo una gestione del rischio flessibile a tutti i livelli.',
  'faq.trading.q2': 'Che leva finanziaria offrite?',
  'faq.trading.a2': 'Offriamo una leva competitiva fino a 1:100 per il trading di metalli preziosi, consentendoti di massimizzare il potenziale mantenendo una gestione responsabile del rischio.',
  'faq.trading.q3': 'Ci sono commissioni di trading?',
  'faq.trading.a3': 'Operiamo con un modello basato sullo spread senza commissioni. I nostri spread sono competitivi e trasparenti, senza costi nascosti.',
  'faq.trading.q4': 'Posso utilizzare strategie di trading automatizzate?',
  'faq.trading.a4': 'Sì, la nostra piattaforma MT5 supporta pienamente gli Expert Advisor (EA) e le strategie automatizzate. Puoi sviluppare algoritmi personalizzati o usare robot esistenti.',

  // Platform (FAQ)
  'faq.platform.q1': 'Quali piattaforme di trading supportate?',
  'faq.platform.a1': 'Utilizziamo principalmente MetaTrader 5 (MT5), la piattaforma leader del settore. MT5 è disponibile per desktop (Windows/Mac), dispositivi mobili (iOS/Android) e browser web.',
  'faq.platform.q2': 'La piattaforma MT5 è gratuita?',
  'faq.platform.a2': 'Sì, MT5 è completamente gratuita da scaricare e usare. Forniamo accesso completo a tutte le funzioni, grafici, indicatori e strumenti senza costi aggiuntivi.',
  'faq.platform.q3': 'Posso fare trading da dispositivi mobili?',
  'faq.platform.a3': 'Assolutamente! Le nostre app MT5 per iOS e Android offrono funzionalità complete, grafici in tempo reale, notizie e gestione dell’account ovunque tu sia.',
  'faq.platform.q4': 'Offrite conti demo?',
  'faq.platform.a4': 'Sì, offriamo conti demo gratuiti con fondi virtuali per esercitarti e familiarizzare con la piattaforma prima di investire denaro reale.',

  // Deposits & Withdrawals
  'faq.deposits.q1': 'Quali metodi di deposito accettate?',
  'faq.deposits.a1': 'Accettiamo bonifici bancari, carte di credito/debito (Visa, MasterCard) e vari metodi di pagamento elettronici. Tutti i depositi sono trattati in modo sicuro ed efficiente.',
  'faq.deposits.q2': 'Quanto tempo richiede l’elaborazione dei depositi?',
  'faq.deposits.a2': 'I depositi con carta sono di solito istantanei, mentre i bonifici bancari possono richiedere 1–3 giorni lavorativi. I pagamenti elettronici vengono generalmente elaborati in poche ore.',
  'faq.deposits.q3': 'Sono previste commissioni di deposito?',
  'faq.deposits.a3': 'Non addebitiamo commissioni per la maggior parte dei metodi di deposito. Tuttavia, la tua banca o il tuo provider di pagamento potrebbe applicare tariffe proprie.',
  'faq.deposits.q4': 'Come posso prelevare i miei fondi?',
  'faq.deposits.a4': 'I prelievi possono essere richiesti tramite il portale clienti. I fondi vengono generalmente restituiti con lo stesso metodo utilizzato per il deposito, con tempi variabili a seconda del metodo.',

  // Security
  'faq.security.q1': 'Come proteggete le mie informazioni personali?',
  'faq.security.a1': 'Utilizziamo una crittografia di livello bancario (SSL a 256 bit) per proteggere tutte le trasmissioni di dati. Le tue informazioni sono archiviate in modo sicuro e non vengono mai condivise con terze parti senza consenso.',
  'faq.security.q2': 'È disponibile l’autenticazione a due fattori?',
  'faq.security.a2': 'Sì, consigliamo vivamente di abilitare la 2FA per il tuo account. Aggiunge un ulteriore livello di sicurezza contro accessi non autorizzati.',
  'faq.security.q3': 'Cosa succede se dimentico la password?',
  'faq.security.a3': 'Puoi reimpostare la password tramite il link “Password dimenticata” nella pagina di login. Riceverai un link sicuro via e-mail per crearne una nuova.',
  'faq.security.q4': 'Come garantite condizioni di trading eque?',
  'faq.security.a4': 'Forniamo prezzi trasparenti con feed di mercato in tempo reale, nessuna intermediazione di dealing desk e rigorosa conformità normativa per garantire condizioni eque ed etiche per tutti i clienti.',

  // Hero (extra)
  'hero.browseFAQ': 'Consulta le FAQ',
  'hero.contactSupport': 'Contatta il supporto',

  // Contact CTA
  'contactCTA.phoneTitle': 'Supporto telefonico',
  'contactCTA.phoneDesc': 'Parla direttamente con i nostri specialisti',
  'contactCTA.callNow': 'Chiama ora',
  'contactCTA.emailTitle': 'Supporto via e-mail',
  'contactCTA.emailDesc': 'Ottieni risposte dettagliate per iscritto',
  'contactCTA.sendMsg': 'Invia messaggio',
  'contactCTA.chatTitle': 'Chat dal vivo',
  'contactCTA.chatDesc': 'Assistenza tramite messaggistica istantanea',
  'contactCTA.available': 'Disponibile 24/7',
  'contactCTA.startChat': 'Avvia chat',
  'contactCTA.title': 'Hai ancora bisogno di aiuto?',
  'contactCTA.subtitle': 'Il nostro team di supporto è disponibile 24/7 per assisterti con qualsiasi domanda o dubbio.',
  "androidDownload.title": "Scarica MetaTrader 5",
  "androidDownload.description": "Verrai reindirizzato automaticamente a Google Play. Se Google Play non è disponibile sul tuo dispositivo, puoi scaricare direttamente l’APK.",
  "androidDownload.autoRedirect": "Reindirizzamento a Google Play tra {{seconds}} secondi",
  "androidDownload.openGooglePlay": "Apri Google Play",
  "androidDownload.downloadApk": "Scarica APK direttamente",
  "androidDownload.hint": "Se Google Play non si apre, tocca “Scarica APK direttamente”.",
  'windowsDownload.pageTitle': 'Scarica Windows MT5',
  'windowsDownload.pageDesc': 'Scegli la versione di installazione più adatta.',
  'windowsDownload.badge': 'Download Windows MT5',
  'windowsDownload.title': 'Scegli il pacchetto di installazione',
  'windowsDownload.description': 'Scegli un pacchetto di installazione Windows MT5. La Gold Label Smooth Stable Version è consigliata agli utenti della Cina continentale e di Hong Kong. Puoi anche scegliere l’installer ufficiale.',
  'windowsDownload.smoothTitle': '1. Gold Label Smooth Stable Version',
  'windowsDownload.smoothDesc': 'Consigliato per utenti Windows in Cina continentale / Hong Kong. Gli utenti di altre regioni possono usarlo se l’installer ufficiale risulta poco pratico.',
  'windowsDownload.smoothButton': 'Scarica Gold Label Smooth Stable Version',
  'windowsDownload.officialTitle': '2. Installer ufficiale MetaQuotes',
  'windowsDownload.officialDesc': 'Link di download originale. Gli utenti Windows della Cina continentale potrebbero occasionalmente riscontrare problemi di installazione; gli utenti di altre regioni non sono interessati.',
  'windowsDownload.officialButton': 'Scarica installer ufficiale',

  // Economic calendar explorer
  'calendar.hongKongTime': 'Ora di Hong Kong (GMT+8)',
  'calendar.previousDays': '7 giorni precedenti',
  'calendar.nextDays': '7 giorni successivi',
  'calendar.today': 'Oggi',
  'calendar.jumpToDate': 'Vai alla data',
  'calendar.completeView': 'Vista completa',
  'calendar.allDays': 'Tutti i 7 giorni',
  'calendar.events': 'eventi',
  'calendar.impactAll': 'Tutti gli impatti',
  'calendar.impactHigh': 'Alto',
  'calendar.impactMedium': 'Medio',
  'calendar.impactLow': 'Basso',
  'calendar.searchPlaceholder': 'Cerca evento, paese o valuta',
  'calendar.eventsFound': 'eventi visualizzati',
  'calendar.lastUpdated': 'Ultimo aggiornamento',
  'calendar.loadError': 'Il calendario economico è temporaneamente non disponibile.',
  'calendar.noEvents': 'Nessun evento economico corrisponde a questa vista.',
  'calendar.tryAnotherDate': 'Scegli un’altra data o cancella i filtri.',
  'calendar.time': 'Ora',
  'calendar.impact': 'Impatto',
  'calendar.released': 'Pubblicato',
  'calendar.pending': 'In attesa',
  'calendar.disclaimer': 'Gli orari sono espressi nell’ora di Hong Kong. I dati possono essere rivisti e sono forniti solo a scopo informativo.',
  'news.tab.newsDesc': 'Ultime notizie di mercato, analisi sull’oro e contenuti educativi',
  'news.tab.calendarDesc': 'Consulta eventi economici importanti e pubblicazioni nei giorni vicini',
  'news.autoRefresh': 'Le notizie vengono aggiornate automaticamente',

  'news.tabs.news': 'Notizie',
  'news.tabs.calendar': 'Calendario economico',

};

export default common;
